export default __webpack_public_path__ + "static/media/EMAIL_CONTACTO.0db384e1.png";